import { KeyValue } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TableSection } from 'src/app/model/shared/table-section';

@Component({
  selector: 'app-ndc-product-update-notifications-page-table-section',
  templateUrl: './ndc-product-update-notifications-page-table-section.component.html',
  styleUrls: ['./ndc-product-update-notifications-page-table-section.component.scss']
})
export class NdcProductUpdateNotificationsPageTableSectionComponent implements OnInit {
  @Input() tableData: Map<string, any> = new Map();
  @Input() tableSections: TableSection[] = [];
  @Input() productUpdateNoteFound: boolean = false;
  @Input() showItemsWithoutReversingOrder: boolean = false;
  constructor() {}

  ngOnInit(): void {}
  reverseOrder = (a: KeyValue<any, any>, b: KeyValue<any, any>): number => {
    return a.key > b.key ? -1 : b.key > a.key ? 1 : 0;
  };
  getMonthAndYearInTexts(monthAndYear: string) {
    const monthAndYearArray = monthAndYear.split('-');
    const titleYear = monthAndYearArray[0];
    const titleMonthInDigits = monthAndYearArray[1];
    let monthInStringFormat = '';
    switch (titleMonthInDigits) {
      case '01' || '1':
        monthInStringFormat = 'January';
        break;
      case '02' || '2':
        monthInStringFormat = 'February';
        break;
      case '03' || '3':
        monthInStringFormat = 'March';
        break;
      case '04' || '4':
        monthInStringFormat = 'April';
        break;
      case '05' || '5':
        monthInStringFormat = 'May';
        break;
      case '06' || '6':
        monthInStringFormat = 'June';
        break;
      case '07' || '7':
        monthInStringFormat = 'July';
        break;
      case '08' || '8':
        monthInStringFormat = 'August';
        break;
      case '09' || '9':
        monthInStringFormat = 'September';
        break;
      case '10':
        monthInStringFormat = 'October';
        break;
      case '11':
        monthInStringFormat = 'November';
        break;
      case '12':
        monthInStringFormat = 'December';
        break;
    }

    const titleInMonthAndYearStringFormat = `${monthInStringFormat} ${titleYear}`;
    return titleInMonthAndYearStringFormat;
  }
}
